// extracted by mini-css-extract-plugin
export default {"header":"info_header__Y4s6Z","textContent":"info_textContent__MoaDo","logo":"info_logo__yK2wm"};